import React, {useEffect, useState} from "react";

import axios from "config/axiosConfig";
import dateFormat from "dateformat";
import {useLocation, useNavigate, useSearchParams} from "react-router-dom";
import {Pagination} from "page/util/Pagination";

const nowYear = () => {
    const now = new Date();
    return now.getFullYear();
}

function List() {
    const [searchParams, setSearchParams] = useSearchParams();
    const [paginationDto, setPaginationDto] = useState();
    const [contents, setContents] = useState([]);
    const [years, setYears] = useState([2024]);
    const navigate = useNavigate();

    const page = searchParams.get('page') || "1";
    const year = searchParams.get('year') || 2025;
    const halfYearType = searchParams.get('halfYearType') || "FIRST";
    const membership = searchParams.get('membership') || "BUSINESS";

    const setPage = (page) => {
        searchParams.set('page', page);
        setSearchParams(searchParams)
    }

    const search = (paramPageNo) => {
        if (paramPageNo !== null) {
            setPage(paramPageNo);
        }

        const uri = '/admin/biz/expected-vats?page=' + page + '&year=' + year + '&halfYearType=' + halfYearType + '&membership=' + membership;
        getList(uri);
    };

    const getList = (uri) => {
        axios.get(uri)
            .then((res) => {
                setPaginationDto(res.data);
                setContents(res.data.content);
            });
    };

    const deleteVat = (id) => {
        axios.delete(`/admin/biz/expected-vats/${id}`)
            .then((res) => {
                search(null);
            });
    };

    const navigateToEdit = (bizNo, bizName, vatId) => {
        let uri = "/page/biz/expected/vat/edit?bizNo=" + bizNo + "&bizName=" + bizName + "&year=" + year + "&halfYear=" + halfYearType + "&membership=" + membership + "&pageNo=" + page;
        if (vatId !== null) {
            uri = uri.concat(`&vatId=${vatId}`)
        }

        navigate(uri);
    };

    useEffect(() => {
        const uri = `/admin/biz/expected-vats?page=${page}&year=${year}&halfYearType=${halfYearType}&membership=${membership}`;
        getList(uri);
    }, [page]);

    useEffect(() => {
        const initYears = [];
        for (let i = 2024; i <= nowYear(); i++) {
            initYears.push(i);
        }
        setYears(initYears.reverse());

        if (!searchParams.has('year')) {
            searchParams.set('year', initYears.at(0));
            setSearchParams(searchParams);
        }

        // 쿼리 파라미터가 없는 경우에만 halfYearType을 설정
        // if (!searchParams.has('halfYearType')) {
        //     const date = new Date();
        //     let month = date.getMonth() + 1;
        //     searchParams.set('halfYearType', (month >= 1 && month <= 6) ? 'FIRST' : 'SECOND');
        //     setSearchParams(searchParams);
        // }
    }, []);

    return (
        <div className="App">
            <div className="wrapper">
                <div className="content-wrapper" style={{marginLeft: '0px'}}>
                    <div className="content-header">
                    <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-12">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item active">예상부가세 보고서 목록</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>

                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-tools" style={{marginTop: '40px'}}>
                                            <button type="submit" className="btn btn-info float-right" style={{width: '80px', marginRight: '10px'}} onClick={ () => search(1)}>검색</button>

                                            <select className="form-control float-right"
                                                    style={{width: '200px', marginRight: '10px'}}
                                                    onChange={ (e) => {
                                                        searchParams.set('membership', e.target.value);
                                                        setSearchParams(searchParams);
                                                    }}
                                                    value={membership}>
                                                <option value="BUSINESS">BUSINESS</option>
                                                <option value="BASIC">BASIC</option>
                                                <option value="">ALL</option>
                                            </select>
                                            <select className="form-control float-right" style={{width: '200px', marginRight: '10px'}}
                                                    onChange={ (e) => {
                                                        searchParams.set('halfYearType', e.target.value);
                                                        setSearchParams(searchParams);
                                                    }}
                                                    value={halfYearType}>
                                                <option value="FIRST">1 기</option>
                                                <option value="SECOND">2 기</option>
                                            </select>
                                            <select className="form-control float-right" style={{width: '200px', marginRight: '10px'}}
                                                    onChange={ (e) => {
                                                        searchParams.set('year', e.target.value);
                                                        setSearchParams(searchParams);
                                                    }}
                                                    value={year}>
                                                {
                                                    years.map(year => {
                                                        return (
                                                            <option value={year} key={year}>{year}년</option>
                                                        )
                                                    })
                                                }
                                            </select>
                                        </div>

                                        <div className="card-body table-responsive p-0" style={{marginTop: '20px'}}>
                                            <table className="table table-hover text-nowrap" style={{textAlign: "center"}}>
                                                <thead>
                                                <tr>
                                                    <th>bizId</th>
                                                    <th>사업자명</th>
                                                    <th>사업자번호</th>
                                                    <th>멤버십</th>
                                                    <th>보고서</th>
                                                    <th>생성일</th>
                                                    <th>노출여부</th>
                                                    <th>삭제</th>
                                                    <th>수정</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {
                                                    contents.map(item => {
                                                        return item.expectedVatCreatedAt === null ?
                                                            (
                                                                <tr key={item.bizId}>
                                                                    <td>{item.bizId}</td>
                                                                    <td>{item.bizName}</td>
                                                                    <td>{item.bizNo}</td>
                                                                    <td>{item.bizMembershipType}</td>
                                                                    <td colSpan={4}
                                                                        style={{textAlign: "center", color: "red"}}>보고서
                                                                        미생성
                                                                    </td>
                                                                    <td>
                                                                        <button type="button"
                                                                                className="btn btn-outline-primary btn-sm"
                                                                                style={{width: '70px'}}
                                                                                onClick={() => navigateToEdit(item.bizNo, item.bizName, null)}>
                                                                            생성
                                                                        </button>
                                                                    </td>
                                                                </tr>
                                                            )
                                                            :
                                                            (
                                                                <tr key={item.bizId}>
                                                                    <td>{item.bizId}</td>
                                                                    <td>{item.bizName}</td>
                                                                    <td>{item.bizNo}</td>
                                                                    <td>{item.bizMembershipType}</td>
                                                                    <td>{item.expectedVatYear}년 {item.expectedVatHalfYearType === 'FIRST' ? 1 : 2}기
                                                                        확정 예상 부가세 보고서
                                                                    </td>
                                                                    <td>{dateFormat(item.expectedVatCreatedAt, 'yyyy-mm-dd HH:mm')}</td>
                                                                    <td>{item.expectedVatVisible ? 'O' : 'X'}</td>
                                                                    <td>
                                                                        <button
                                                                            className="btn btn-outline-primary btn-sm"
                                                                            style={{width: '70px'}}
                                                                            onClick={() => deleteVat(item.vatId)}>
                                                                            삭제
                                                                        </button>
                                                                    </td>
                                                                    <td>
                                                                        <button type="button"
                                                                                className="btn btn-outline-primary btn-sm"
                                                                                style={{width: '70px'}}
                                                                                onClick={() => navigateToEdit(item.bizNo, item.bizName, item.vatId)}>
                                                                            수정
                                                                        </button>
                                                                    </td>
                                                                </tr>
                                                            )
                                                    })
                                                }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {
                            paginationDto && <Pagination pager={paginationDto} setPage={setPage}/>
                        }

                    </section>
                </div>
            </div>
        </div>
    );
}

export default List;
